"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalityStatusChoices = exports.RiskStatusChoices = exports.isRisk = void 0;
function isRisk(input) {
    return input.risk_number !== undefined;
}
exports.isRisk = isRisk;
var RiskStatusChoices = (function () {
    function RiskStatusChoices() {
    }
    RiskStatusChoices.as_choices = function () {
        return [
            { display_name: gettext("New"), value: RiskStatusChoices.NEW.toString() },
            { display_name: gettext("Open"), value: RiskStatusChoices.OPEN.toString() },
            { display_name: gettext("Closed"), value: RiskStatusChoices.CLOSED.toString() },
            { display_name: gettext("Discarded"), value: RiskStatusChoices.DISCARDED.toString() },
        ];
    };
    RiskStatusChoices.NEW = 10;
    RiskStatusChoices.OPEN = 20;
    RiskStatusChoices.CLOSED = 30;
    RiskStatusChoices.DISCARDED = 40;
    RiskStatusChoices.INCOMPLETE = [10, 20];
    RiskStatusChoices.COMPLETE = [30, 40];
    return RiskStatusChoices;
}());
exports.RiskStatusChoices = RiskStatusChoices;
var CausalityStatusChoices = (function () {
    function CausalityStatusChoices() {
    }
    CausalityStatusChoices.toList = function () {
        return [this.OPEN, this.CLOSED, this.DISCARDED];
    };
    CausalityStatusChoices.as_choices = function () {
        return [
            { display_name: gettext("Open"), value: CausalityStatusChoices.OPEN.toString() },
            { display_name: gettext("Closed"), value: CausalityStatusChoices.CLOSED.toString() },
            { display_name: gettext("Discarded"), value: CausalityStatusChoices.DISCARDED.toString() },
        ];
    };
    CausalityStatusChoices.OPEN = 10;
    CausalityStatusChoices.CLOSED = 20;
    CausalityStatusChoices.DISCARDED = 30;
    CausalityStatusChoices.INCOMPLETE = [10];
    CausalityStatusChoices.COMPLETE = [20, 30];
    return CausalityStatusChoices;
}());
exports.CausalityStatusChoices = CausalityStatusChoices;
